// ── El cuerpo de un correo: ¿HTML o texto plano? (2026-10-21) ────────────────
//
// `messages.body` guarda lo que traiga el correo: el HTML si lo tiene, y si no
// el texto plano (services/email.ts, `bodyHtml ?? bodyText`). El visor metía
// las dos cosas tal cual dentro de un <body> HTML, y un correo de solo texto
// salía en un único párrafo: el navegador junta los saltos de línea. Pasó con
// la respuesta automática de Dynamic Primary Care, que en Apple Mail se ve en
// renglones.
//
// Un solo criterio para todos los que tienen que decidir: el visor de correo
// (web) y la cita al responder o reenviar (server/mail/compose.ts).
/**
 * Una etiqueta HTML conocida, abierta o cerrada. Por nombre y no por "cualquier
 * cosa entre < y >": un correo de texto trae direcciones como
 * `Ana <ana@dominio.com>` y enlaces como `<https://...>`, y eso no es HTML.
 */
const ETIQUETA_HTML = /<\/?(?:!doctype|html|head|body|meta|style|div|p|br|span|a|img|table|tbody|thead|tr|td|th|font|b|i|u|s|strong|em|ul|ol|li|h[1-6]|blockquote|pre|hr|center|section|article|header|footer|o:p)(?=[\s>/])/i;
/** Si el cuerpo guardado de un correo es HTML (y no texto plano). */
export function esCuerpoHtml(cuerpo) {
    return ETIQUETA_HTML.test(cuerpo);
}
/**
 * Un cuerpo de texto plano como HTML que se ve igual que en un cliente de
 * correo: los saltos y las líneas en blanco donde estaban, y el texto escapado
 * para que un `<` del texto no se lea como etiqueta.
 */
export function textoPlanoACuerpoHtml(texto) {
    const escapado = texto
        .replace(/\r\n?/g, '\n')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    return `<div style="white-space:pre-wrap;overflow-wrap:anywhere;font-family:inherit">${escapado}</div>`;
}
//# sourceMappingURL=cuerpoDeCorreo.js.map